export enum FieldTooltipVariants {
  WITH_ICON = 'with-icon',
  WHOLE_INPUT = 'whole-input',
}
